import { render, staticRenderFns } from "./app-tile-button.vue?vue&type=template&id=34edd126&scoped=true"
import script from "./app-tile-button.vue?vue&type=script&lang=ts"
export * from "./app-tile-button.vue?vue&type=script&lang=ts"
import style0 from "./app-tile-button.vue?vue&type=style&index=0&id=34edd126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34edd126",
  null
  
)

export default component.exports